import { render, staticRenderFns } from "./NetaAttractionDetailsMenuComponent.vue?vue&type=template&id=5b981811&scoped=true&"
import script from "./NetaAttractionDetailsMenuComponent.vue?vue&type=script&lang=js&"
export * from "./NetaAttractionDetailsMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaAttractionDetailsMenuComponent.vue?vue&type=style&index=0&id=5b981811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b981811",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b981811')) {
      api.createRecord('5b981811', component.options)
    } else {
      api.reload('5b981811', component.options)
    }
    module.hot.accept("./NetaAttractionDetailsMenuComponent.vue?vue&type=template&id=5b981811&scoped=true&", function () {
      api.rerender('5b981811', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-attraction/NetaAttractionDetailsMenuComponent.vue"
export default component.exports